import { CourseService } from '@/app/services/courses'

import HOMEPAGE_SEARCH_INDEX_CONFIG from '@/app/config/homepage'
import { ROUTES } from '@/app/lib/constants'
import { loadLocaleFiles } from '@/app/lib/load-locale'
import { CoursePage } from '@/app/modules/course/pages/CoursePage'
import { generateTypesenseScopedKey } from '@/app/modules/search/lib/keys'
import { ApiService } from '@/app/services/ApiService'
import { CourseInclude } from '@/types/course'
import { isBoom } from '@hapi/boom'

const cookieName = process.env.NEXT_PUBLIC_AUTH_COOKIE_NAME

const frontendSearchApiKey = process.env.NEXT_SEARCH_INDEX_FRONTEND_API_KEY

export async function getServerSideProps(context) {
  const {
    params: { id },
    req,
    locale,
  } = context

  ApiService.setAccessToken(req.cookies?.[cookieName!] || '')
  ApiService.setHeader('accept-language', locale ?? 'en')

  try {
    const { data: course } =
      (await CourseService.getCourseById(id, undefined, [
        CourseInclude.FinancialTermSponsor,
      ])) || {}

    if (!course) {
      return {
        notFound: true,
      }
    }

    if (!Array.isArray(course.cohorts) || course.cohorts?.length === 0) {
      return {
        notFound: true,
      }
    }

    const searchScopedKey =
      HOMEPAGE_SEARCH_INDEX_CONFIG.enabled && frontendSearchApiKey
        ? generateTypesenseScopedKey(
            frontendSearchApiKey,
            '{"filter_by":"published:=true"}'
          )
        : ''

    return {
      props: {
        course,
        searchScopedKey,
        messages: await loadLocaleFiles(context.locale, [
          'navigation',
          'strings',
        ]),
      },
    }
  } catch (e) {
    console.error(e)
    if (isBoom(e, 404)) {
      return {
        notFound: true,
      }
    } else if (isBoom(e, 401)) {
      return {
        redirect: {
          destination: `${ROUTES.logout}?redirectTo=/${locale}${ROUTES.courses}/${id}`,
          permanent: false,
          locale,
        },
      }
    } else if (isBoom(e, 403)) {
      return {
        redirect: {
          destination: `/${locale}${ROUTES.accessDenied}`,
          permanent: false,
          locale,
        },
      }
    }

    throw e
  }
}

export default CoursePage
